import { ObjectValues } from 'type-alias';

export const USER_LOGIN_TYPE = {
  OAuth: 'OAuth',
  Email: 'Email',
  Phone: 'Phone',
  MagicLink: 'MagicLink',
  ShopifyMultipass: 'ShopifyMultipass',
  Auth0: 'Auth0',
  NotDefined: 'NotDefined',
} as const;

export type USER_LOGIN_TYPE_VALUES = ObjectValues<typeof USER_LOGIN_TYPE>;
